// extracted by mini-css-extract-plugin
export var integrationButton = "_81-0";